import { Modal } from '../components/Modal';

type Props = {
    onClose: () => void;
    onConfirm: () => void;
    text?: string;
};

/**
 * Generic destructive confirm. Used when hiding a task forever (spec calls
 * this out: задание закроется навсегда для данного пользователя).
 */
export function ConfirmDeleteModal({ onClose, onConfirm, text }: Props) {
    return (
        <Modal title="Удалить задание?" onClose={onClose}>
            <div className="popup-hero">⚠️</div>
            <p className="popup-text text-center">
                {text ?? 'Это задание закроется навсегда для данного пользователя.'}
            </p>
            <div style={{ display: 'flex', gap: 10 }}>
                <button type="button" className="action-btn btn-red" onClick={onConfirm}>
                    Скрыть навсегда
                </button>
                <button type="button" className="action-btn btn-mute" onClick={onClose}>
                    Отмена
                </button>
            </div>
        </Modal>
    );
}
